import { useCallback, useEffect, useMemo, useState } from "react";
import GridTable from "../../common/component/GridTable";
import Wrapper from "../../common/uicomponent/wrapper";
import { useApiHandler } from "../../common/utils/customapiHandler";
import { all_routes } from "../../router/all_routes";
import { userController } from "./controller";
import { columnDefs } from "./coldefs";
import { useLocation, useNavigate } from "react-router-dom";
import CenteredLoader from "../../common/component/CenteredLoader";
interface FormState {
  loading: any;
  error?: string;
  tableData?: any;
}
const UsreList = () => {
  const route = all_routes;
  const { loadTableData } = useApiHandler();
  const navigate = useNavigate();
  const location = useLocation();
  const { CompCode } = userController();
  const [listData, setListData] = useState({
    tableData: [],
    loading: false,
  });
  const updateState = (newState: Partial<FormState>) => {
    setListData((prev) => ({ ...prev, ...newState }));
  };
  useEffect(() => {
    console.log("location from list", location?.state);
    tableListHandler();
  }, []);
  const tableListHandler = useCallback(async () => {
    await loadTableData({
      url: `Report/GetCompanyUserMasterList?CompCode=${CompCode}`,
      setState: setListData,
      setLoading: (value: any) => updateState({ loading: value }),
      key: "tableData",
    });
  }, [loadTableData, updateState]);
  const handleEdit = (code: number) => {
    console.log("code", code);
    const navigateData = {
      code,
      navigate: location?.state,
    };
    console.log("navigateData", navigateData);
    navigate(route.userpage, { state: navigateData });
  };
  const colDef = useMemo(
    () =>
      columnDefs({
        onEdit: (row) => handleEdit(row.Code),
        onDelete: () => { },
      }),
    [handleEdit]
  );
  // custsupplogin
  return (
    <Wrapper
      header="User List"
      subHeader=""
      link={route.userpage}
      linkState={location?.state}
      addButton="Create User"
      importButtonName="Customer/Supplier Login"
      extralink={route.custsupplogin}
    >
      {listData?.loading && <CenteredLoader />}
      <GridTable rowData={listData?.tableData || []} columnDefs={colDef} />
    </Wrapper>
  );
};

export default UsreList;
